import { styled } from '@fluentui/react';
import { SearchBase } from './Search.base';
import { getSearchStyles } from './Search.styles';

// Use Fabric Base guidelines since this might be contributed back to Fabric.
export const Search = styled(SearchBase, getSearchStyles, undefined, {
  scope: 'Search',
});
